// UserMembershipsTable.js

import React, { useEffect, useState } from 'react';
import B2BTable from '../../../b2b-common/B2BTable';
import RolesList from '../user/RolesList';
import { CheckBox, CheckBoxOutlineBlank, SignalWifiStatusbarNullOutlined } from '@mui/icons-material';

import './UserMembershipsTable.css';
import { toLocaleDate, toLocaleDateTime } from '../../../b2b-common/helpers';

const UserMembershipsTable = ({ memberships, onSelectedUserMembership, pagesCount, currentPage, onPageChange, tableLoading, pageLoading }) => {

    const headers = [
        { label: 'Organization', align: 'left' },
        { label: 'Roles', align: 'left' },
        { label: 'Membership Date', align: 'left' },
        { label: 'Last Login Date', align: 'left' },
        { label: 'Enabled', align: 'center' },
    ];

    const rows = memberships.content ? memberships.content.map((membership) => ({
        id: membership.organization.organizationUUID,
        cells: [
            { content: `${membership.organization.organizationName}`, align: 'left' },
            { content: (<RolesList roles={membership.roles} />), align: 'center' },
            { content: `${toLocaleDateTime(membership.membershipDate)}`, align: 'left' },
            { content: `${toLocaleDateTime(membership.lastLoginDate, true)}`, align: 'left' },
            {
                content: membership.enabled ? (
                    <CheckBox className="icon checked" />
                ) : (
                    <CheckBoxOutlineBlank className="icon" />
                ),
                align: 'center',
            },
        ],
    })) : [];

    //console.log(rows);
    //console.log(memberships);

    return <B2BTable
        pagesCount={pagesCount}
        currentPage={currentPage}
        onPageChange={onPageChange}
        headers={headers} rows={rows}
        rowLoading={null}
        tableLoading={tableLoading}
        pageLoading={pageLoading}
        onRowClick={onSelectedUserMembership}
        className={'user-memberships-table'}
    />;
}
export default UserMembershipsTable;